function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.70711 4.79289L4.79289 3.70711C5.18342 3.31658 5.81658 3.31658 6.20711 3.70711L12 9.5L17.7929 3.70711C18.1834 3.31658 18.8166 3.31658 19.2071 3.70711L20.2929 4.79289C20.6834 5.18342 20.6834 5.81658 20.2929 6.20711L14.5 12L20.2929 17.7929C20.6834 18.1834 20.6834 18.8166 20.2929 19.2071L19.2071 20.2929C18.8166 20.6834 18.1834 20.6834 17.7929 20.2929L12 14.5L6.20711 20.2929C5.81658 20.6834 5.18342 20.6834 4.79289 20.2929L3.70711 19.2071C3.31658 18.8166 3.31658 18.1834 3.70711 17.7929L9.5 12L3.70711 6.20711C3.31658 5.81658 3.31658 5.18342 3.70711 4.79289Z"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Cross.23152050.svg";
export { ForwardRef as ReactComponent };